import { render } from "./WorkFlow.vue?vue&type=template&id=24a5f236&scoped=true"
import script from "./WorkFlow.vue?vue&type=script&lang=js"
export * from "./WorkFlow.vue?vue&type=script&lang=js"

import "./WorkFlow.vue?vue&type=style&index=0&id=24a5f236&scoped=true&lang=css"

import exportComponent from "D:\\projects\\wmsapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24a5f236"]])

export default __exports__